module.exports = __webpack_public_path__ + "img/icon-timesheet.58718feb.svg";